import React, { CSSProperties } from 'react';
import { TypographySettings } from '../../../types';

const isHex = ( value: string | undefined ): value is string =>
	!! value && /^#[0-9a-f]{3,8}$/i.test( value );

/**
 * Gradient fill of the letters, or nothing for solid text.
 *
 * @param settings Text style.
 */
export const getTextFill = (
	settings: TypographySettings
): CSSProperties | undefined => {
	if (
		settings.colorType !== 'gradient' ||
		! isHex( settings.gradientFrom ) ||
		! isHex( settings.gradientTo )
	) {
		return undefined;
	}
	return {
		backgroundImage: `linear-gradient(${
			Number( settings.gradientAngle ) || 0
		}deg, ${ settings.gradientFrom } 0%, ${ settings.gradientTo } 100%)`,
		WebkitBackgroundClip: 'text',
		backgroundClip: 'text',
		WebkitTextFillColor: 'transparent',
	};
};

interface TextFillProps {
	text: TypographySettings;
	children: React.ReactNode;
}

/**
 * Wraps a text's words so a gradient fill only paints the letters (the
 * element around it keeps its own background, e.g. a button or badge).
 *
 * @param props Text style and words.
 */
const TextFill: React.FC< TextFillProps > = ( { text, children } ) => {
	const fill = getTextFill( text );
	if ( ! fill ) {
		return <>{ children }</>;
	}
	return (
		<span className="sb-text-fill" style={ fill }>
			{ children }
		</span>
	);
};

export default TextFill;
